import DataServiceSQL from "../../DataService/DataServiceSQL";
import UserFunctionsGetter from '../../Controller/getSQLUserFunctions.js';
import React, { useState, useEffect, useMemo, useRef } from "react";
import { Row, Col } from 'reactstrap';
import { useTable } from "react-table";
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import AddStaff from './AddStaff.js';
import {FormattedMessage, useIntl} from 'react-intl';
import { Icon } from 'semantic-ui-react';
import UpdateStaffRole from '../../Popup/UpdateStaffRole.js';
import UpdateStaffAnonymity from '../../Popup/UpdateStaffAnonymity.js';
import LinkOffIcon from '@material-ui/icons/LinkOff';

// Returns true if the user row has practitioner data (RPPS, profession or category)
const rowIsPractitioner = (user) => {
  if (user.rpps && /^\d{9,11}$/.test(String(user.rpps).trim())) return true;
  if (user.profession && user.profession !== "null" && user.profession !== "") return true;
  if (user.category  && user.category  !== "null" && user.category  !== "") return true;
  return false;
};

const StaffList = (props) => {
  const [user_list, setUserList] = useState([]);
  const [searchUserMail, setSearchUserMail] = useState("");
  const [display_Add_User_Popup, setAddUserPopup] = useState(false);
  const [display_Update_Staff_Popup, setUpdateStaffPopup] = useState(false);
  const [display_Delete_Staff_Popup, setDeleteStaffPopup] = useState(false);
  
  const [current_Id_User, setCurrentUserID] = useState("");
  const [current_anonymity, setCurrentAnonymity] = useState(0);
  const [current_User_Mail, setCurrentUserMail] = useState("");

  const intl = useIntl();

  const staffRef = useRef();
  const allStaffRef = useRef([]);

  staffRef.current = user_list;

  useEffect(() => {
    retrieveStaffList();
  }, 
  //eslint-disable-next-line
  []);

  const onChangeSearchUserMail = (e) => {
    const value = e.target.value;
    setSearchUserMail(value);
    if (value === "") {
      setUserList(allStaffRef.current);
    }
  };

  const onKeyDownSearchUserMail = (e) => {
    if (e.key === 'Enter' && searchUserMail.length >= 3) {
      findUserByUserMail();
    }
  };

  const clearSearch = () => {
    setSearchUserMail("");
    setUserList(allStaffRef.current);
  };

  const retrieveStaffList = async () => {
    let local_staff_list = [];

    // get staff list
    local_staff_list = await UserFunctionsGetter.get_staff_user_list(props.structure_Id);
    if((local_staff_list !== "none")&&(local_staff_list !== undefined)&&(local_staff_list.length !== 0)){ 
      allStaffRef.current = local_staff_list;
      setUserList(local_staff_list);
    }
    else{
      allStaffRef.current = [];
      setUserList([]);
    }
  };

  const findUserByUserMail = () => {
    if (searchUserMail.length !== 0) {
      const filtered = allStaffRef.current.filter(user =>
        user.email && user.email.toLowerCase().includes(searchUserMail.toLowerCase())
      );
      setUserList(filtered);
    } else {
      setUserList(allStaffRef.current);
    }
  };

  const handleAnonChange = async (username, anonymised_patient) => {
    var data = {
      "resourceType" : "Practitioner",
      "anonymity": !anonymised_patient
    }
    await (DataServiceSQL.updatePractitionnerReq_fhir(username, data))
      .then((response) => {
        null;
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const UpdateUser = async (rowIndex, anonymised_patient) => {
    setCurrentUserID(staffRef.current[rowIndex].email);
    setCurrentAnonymity(anonymised_patient);
    manageUpdateStaffDisplay();
  };

  const DeleteUser = (rowIndex) => {
    setCurrentUserID(staffRef.current[rowIndex].email);
    manageDeleteStaffDisplay();
  };

  const manageAddNewUserDisplay = () => {
    setAddUserPopup(!display_Add_User_Popup);
  };

  const manageUpdateStaffDisplay = () => {
    setUpdateStaffPopup(!display_Update_Staff_Popup);
  };

  const manageDeleteStaffDisplay = () => {
    setDeleteStaffPopup(!display_Delete_Staff_Popup);
  };

  const closeAfterAdding = () => {
    retrieveStaffList()
    manageAddNewUserDisplay();
  };

  const closeAfterUpdate = () => {
    retrieveStaffList()
    manageUpdateStaffDisplay();
  };

  const closeAfterDeletion = () => {
    retrieveStaffList()
    manageDeleteStaffDisplay();
  };

  let headersList = [
      {
        Header: "Mail",
        accessor: "email",
        Cell: (cellProps) => {
          const user = cellProps.row.original;
          const isPract = rowIsPractitioner(user);
          return (
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <span>{cellProps.value}</span>
              {isPract && (
                <span
                  data-testid="staff-practitioner-badge"
                  title={user.profession || user.rpps || "Praticien"}
                  style={{
                    display: "inline-flex", alignItems: "center", gap: 3,
                    background: "#e3f2fd", color: "#1565c0",
                    border: "1px solid #90caf9", borderRadius: 10,
                    padding: "1px 7px", fontSize: "0.76em", fontWeight: 600,
                    whiteSpace: "nowrap", lineHeight: 1.5,
                  }}
                >
                  <span role="img" aria-label="practitioner">&#x1F9BA;</span>
                  {user.profession ? ` ${user.profession}` : "Praticien"}
                </span>
              )}
            </div>
          );
        },
      },      
      {
        Header: "Anonymity",
        accessor: "anonymised_patient",
        Cell: (props) => {
          const rowIdx = props.row.id;
          return (
            <div>
            { (props.row.original.anonymised_patient === 1) ?
              <div>
                  yes
              </div>
              :
              <div>
                  no
              </div>
            }
            </div>
          );
        },
      },
    
  ]
  if (props.accountInformation.readOnly !== true) {
    headersList.push({
        Header: "Action",
        accessor: "actions",
        Cell: (props) => {
          const rowIdx = props.row.id;
          return (
            <div>
              <span onClick={() => UpdateUser(rowIdx, props.row.original.anonymised_patient)}
                data-tooltip="Modifier" >
                <i className="far fa-edit action mr-2"></i>
              </span>
              <span onClick={() => DeleteUser(rowIdx)} data-tooltip="Revoke staff rights">
                <LinkOffIcon color="inherit" fontSize="inherit" />
              </span>
            </div>
          );
        },
    },)
  }

  let columns = useMemo(
    () => headersList,
    //eslint-disable-next-line
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data: user_list
  });

  return (
    <div>
      <Row>
        <Col sm={8} style = {{width:"50%"}}>
          <Row style={{ flexWrap: "nowrap", alignItems: "center" }}>
            <div style={{ position: "relative", width: "auto", maxWidth: "70%" }}>
              <input
                type="text"
                className="form-control"
                placeholder={intl.formatMessage({ id: 'staff.search.placeholder' })}
                value={searchUserMail}
                onChange={onChangeSearchUserMail}
                onKeyDown={onKeyDownSearchUserMail}
                style={{ paddingRight: searchUserMail.length > 0 ? "28px" : undefined }}
              />
              {searchUserMail.length > 0 && (
                <span
                  onClick={clearSearch}
                  style={{ position: "absolute", right: "20px", top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "#999", fontSize: "1.1em", lineHeight: 1 }}
                  title={intl.formatMessage({ id: 'staff.search.clear' })}
                >
                  &times;
                </span>
              )}
            </div>
            <button className="btn btn-outline-secondary" onClick={findUserByUserMail} style={{ width: "auto", marginLeft: "4px" }}>
              <Icon name='search' size='large' inverted color='black'/>
            </button>
          </Row>
        </Col>
        <Col sm={4} style={{ width: "50%", display: "flex", flexDirection: "row", justifyContent: "right"}}>
          {props.accountInformation.readOnly === true ?
            null
            :
          <button className="btn btn-sm btn-success" onClick={manageAddNewUserDisplay} style={{ width: "100px", fontSize: "0.9em"}}>
            <FormattedMessage id="button.add" defaultMessage="Add" />
          </button>
          }
        </Col>
      </Row>
      <br/>
      <Row style={{ maxHeight:"65vh", overflowY: 'auto'}}>
        <table
          className="table table-striped table-bordered"
          {...getTableProps()}
        >
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </Row>
      {display_Add_User_Popup ? <AddStaff cancelPopup={manageAddNewUserDisplay} closeAfterAdd={closeAfterAdding} structure_Id={props.structure_Id} accountInformation={props.accountInformation}/> : null}
      {display_Update_Staff_Popup ? <UpdateStaffAnonymity cancelPopup={manageUpdateStaffDisplay} closeAfterUpdate={closeAfterUpdate} id={current_Id_User} anonymity={current_anonymity} object_type="staff"/> : null}
      {display_Delete_Staff_Popup ? <UpdateStaffRole cancelPopup={manageDeleteStaffDisplay} closeAfterDelete={closeAfterDeletion} id={current_Id_User} userMail={current_User_Mail} FK_Structure={props.structure_Id} object_name={current_User_Mail} object_type={"staff"}/> : null}
    </div>
  );
};

export default withStyles(Constants.styles)(StaffList);
